import React, { ChangeEvent } from "react";
import { Card } from "primereact/card";
import { InputText } from "primereact/inputtext"; // Import InputText
import { Button } from "primereact/button"; // Import Button
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import MapsHomeWorkOutlinedIcon from "@mui/icons-material/MapsHomeWorkOutlined";

import {
  searchByPropertyId,
  resetContractInfo,
  setIsNewMode,
} from "src/redux/slices/assignBuildingSlice";

import "./AssignBuilding.scss";
import { useTranslation } from "react-i18next";
import { RoutePaths } from "src/resources/enum";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import { toast } from "react-toastify";
import AssignBuildingTitle from "./AssignBuildingTitle";

const Search = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { t } = useTranslation(["common", "assignBuilding"]);
  const [propertyId, setPropertyId] = React.useState<string>("");

  const handleSearch = async (e: any) => {
    e.preventDefault();
    if (!propertyId || propertyId === "") {
      toast.error(t("assignBuildingOptions"));
      return;
    }
    const response = await dispatch(searchByPropertyId(propertyId) as any);
    if (response) {
      if (response.contractInfo) {
        toast.error(t("hasActiveContractValidation"));
      //  dispatch(resetContractInfo());
      //  navigate(RoutePaths.BuildingDetails);
      //  dispatch(setIsNewMode(true));
      }
      if (!response.buildingInfo || response.buildingInfo?.propertyId === "") {
        toast.error(t("noBuildingValidation"));
      } else if (response.contractInfo == null) {
        dispatch(resetContractInfo());
        navigate(RoutePaths.BuildingDetails);
        dispatch(setIsNewMode(true));
      }
    }
  };

  const handleSetPropertyId = (e: ChangeEvent<HTMLInputElement>): void => {
    setPropertyId(e.target.value);
  };
  const handleAddBuildingSurvey = () => {
    navigate(RoutePaths.Survey);
  };
  return (
    <div>
      <AssignBuildingTitle />
      <div className="assign">
        <div className="d-flex justify-content-center align-items-center mb-4 gap-5 assign-card-contents">
          <Card className="assign-card inactive-card">
            <div className="card-header d-flex mb-2 gap-2 justify-content-center">
              <MapsHomeWorkOutlinedIcon />
            </div>
            <h3>{t("existingBuilding")}</h3>
            <form
              className="d-flex flex-column justify-content-center"
              onSubmit={handleSearch}
            >
              <div className="form-control">
               
                <InputText
                  id="propertyId"
                  name="propertyId"
                  placeholder={t("search")}
                  className="w-100"
                  autoComplete="off"
                  onChange={handleSetPropertyId}
                  value={propertyId}
                />
                 <label className="note" htmlFor="propertyId">{t("assignBuildingOptions")}</label>
              </div>

              <Button
                label={t("start")}
                className="light-primary-btn flex-row-reverse"
                icon={<PlayArrowIcon />}
              />
            </form>
          </Card>

          <Card className="assign-card inactive-card">
            <div className="card-header d-flex gap-2 justify-content-center">
              <MapsHomeWorkOutlinedIcon />
            </div>
            <h3>{t("addBuildingSurvey")}</h3>

            <Button
              onClick={handleAddBuildingSurvey}
              label={t("start")}
              className="light-primary-btn flex-row-reverse"
              icon={<PlayArrowIcon />}
            />
          </Card>
        </div>
      </div>
    </div>
  );
};

export default Search;


